import { render, staticRenderFns } from "./DetailClass.vue?vue&type=template&id=4598a434&scoped=true&"
import script from "./DetailClass.vue?vue&type=script&lang=js&"
export * from "./DetailClass.vue?vue&type=script&lang=js&"
import style0 from "./DetailClass.vue?vue&type=style&index=0&id=4598a434&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4598a434",
  null
  
)

component.options.__file = "DetailClass.vue"
export default component.exports